import * as React from 'react';
import { useEffect } from 'react';

import { Grid, IconButton, Paper } from '@mui/material';
import { CancelOutlined } from '@mui/icons-material';

import { CloseVideoDialogEvent } from '../CloseVideoDialogEvent';
import { VideoData } from './VideoData';
import Videojs from '../video.js';

import './VideoPlayerDialogStyles.css';


export interface IVideoPlayerDialogProps {
    videoData?: VideoData;
}

const VideoPlayerDialog = (props: IVideoPlayerDialogProps) => {
    const { videoData } = props;

    let showClosingAnimation: boolean = videoData === undefined;

    const videoJsOptions = {
        preload: "auto",
        playbackRates: [0.5, 1, 1.25, 1.5, 2],
        width: 720,
        height: 300,
        controls: true,
    };
    
    useEffect(() => {
        let videoDiv = document.getElementById("vjs-player-div");

        if(videoDiv !== null) {
            videoDiv.style.borderBottomLeftRadius = "0px";
            videoDiv.style.borderBottomRightRadius = "0px";
        }


        let dialogDiv = document.getElementById("video-dialog-div-container");

        if(dialogDiv !== null) {
            dialogDiv.style.display = "none";
        }

        window.addEventListener("openVideoDialog", showDiv);

        return () => {
            window.removeEventListener("openVideoDialog", () => {});
        }
    }, [])
    
    const handleCloseButton = () => {
        window.dispatchEvent(new CloseVideoDialogEvent());
        hideDiv();
    }

    const hideDiv = () => {
        setTimeout(() => {
            let dialogDiv = document.getElementById("video-dialog-div-container");
            let htmlTag = document.getElementsByTagName("html")[0];


            if(dialogDiv !== null) {
                dialogDiv.style.display = "none";
            }

            htmlTag.style.overflowY = "auto";
        }, 100);
    }

    const showDiv = () => {
        let dialogDiv = document.getElementById("video-dialog-div-container");
        let htmlTag = document.getElementsByTagName("html")[0];

        if(dialogDiv !== null && htmlTag !== null) {
            dialogDiv.style.display = "block";
        }

        htmlTag.style.overflowY = "hidden";
    }

    const handleDialogBackgroundClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if(event.target === document.getElementById("video-dialog-div-container")) {
            window.dispatchEvent(new CloseVideoDialogEvent());
            hideDiv();
        }
    }

    return (
        <div id="video-dialog-div-container" className={`video-player-dialog-container ${showClosingAnimation ? "video-dialog-div-fade-out" : "video-dialog-div-fade-in"}`} onClick={(event) => handleDialogBackgroundClick(event)}>
            <Paper className={`video-player-dialog-paper ${showClosingAnimation ? "video-dialog-paper-fade-out" : "video-dialog-paper-fade-in"}`} elevation={24}>
                <Grid className="video-player-dialog-grid" container direction="column">
                    <Grid className="video-player-dialog-video" item xs>
                        <Videojs {...videoJsOptions}  />
                    </Grid>
                    <Grid className="video-dialog-label-item" item xs>
                        <Grid className="video-dialog-title-grid" container direction="row" columns={4} >
                            <Grid className="video-dialog-title-item" item >
                                <p>{videoData?.title}</p>
                            </Grid>
                            <Grid className="" item style={{width: "auto"}} >
                                <div className="video-dialog-title-divider-div" />
                            </Grid>
                        </Grid>
                        <IconButton onClick={handleCloseButton}>
                            <CancelOutlined />
                        </IconButton>
                    </Grid>
                </Grid>
            </Paper>
        </div>
    )
}

export default VideoPlayerDialog;